
import "./Loader.css"

const LoadingGif = () => {
   return (
      /* From Uiverse.io by adamgiebl */
      <section className="dots-container">
         <div className="dot"></div>
         <div className="dot"></div>
         <div className="dot"></div>
         <div className="dot"></div>
         <div className="dot"></div>
      </section>

   )
};
export default LoadingGif;